// extracted by mini-css-extract-plugin
export default {"add-device-form-container":"AddDeviceToMeasurementDialog_add-device-form-container__t98VQ","add-device-form-header":"AddDeviceToMeasurementDialog_add-device-form-header__PzM8K"};